import { NavLink } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="max-w-6xl mx-auto w-full px-4 py-8 text-sm text-cocoa/80">
      <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3 text-cocoa">
          <img src="/logo.png" alt="Project Tower logo" className="h-8 w-auto" />
          <span className="font-semibold tracking-wide">Project Tower</span>
        </div>
        <nav className="flex flex-wrap items-center gap-4 text-cocoa/80">
          <NavLink
            to="/"
            className="hover:text-cocoa focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
            end
          >
            Home
          </NavLink>
          <NavLink
            to="/programs"
            className="hover:text-cocoa focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
          >
            Programs
          </NavLink>
          <NavLink
            to="/gallery"
            className="hover:text-cocoa focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
          >
            Gallery
          </NavLink>
          <NavLink
            to="/events"
            className="hover:text-cocoa focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
          >
            Events
          </NavLink>
          <NavLink
            to="/partners"
            className="hover:text-cocoa focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
          >
            Partners
          </NavLink>
          <NavLink
            to="/contact"
            className="hover:text-cocoa focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
          >
            Contact
          </NavLink>
          <NavLink
            to="/login"
            className="hover:text-cocoa focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
          >
            Login
          </NavLink>
        </nav>
      </div>
      <div className="mt-6 text-cocoa/60">© {new Date().getFullYear()} Project Tower — Empower a Future</div>
    </footer>
  );
}
